module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Trocar coordenador da ação'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Coordenador atual",
      "readonly": "",
      "max-height": "400"
    },
    model: {
      value: (_vm.integrante.nome),
      callback: function($$v) {
        _vm.$set(_vm.integrante, "nome", $$v)
      },
      expression: "integrante.nome"
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "mt-1"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Novo coordenador",
      "items": _vm.listaIntegrantes,
      "eager": "",
      "item-text": "nome",
      "item-value": "idParticipante",
      "prepend-icon": "dashboard",
      "max-height": "400",
      "return-object": "",
      "required": "",
      "autocomplete": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.novoCoordenador),
      callback: function($$v) {
        _vm.novoCoordenador = $$v
      },
      expression: "novoCoordenador"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": _vm.trocarCoordenador
    }
  }, [_vm._v("Trocar coordenador")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a675964","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/integrantes/trocar-coordenador.vue
// module id = 592
// module chunks = 0